import React from 'react';
import { withStyles } from 'material-ui';
import Table from 'material-ui/Table';
import Paper from 'material-ui/Paper';

const TableWrapper = ({ toolbar, children, classes, study }) => {
    return (
        <Paper className={classes.root}>
            {toolbar ? toolbar : null}
            <div className={study === 'global' ? classes.tableWrapperStudyGlobal : study === 'local' ? classes.tableWrapperStudyLocal : classes.tableWrapper}>
                <Table className={classes.table}>{children}</Table>
            </div>
        </Paper>
    );
};

const styles = theme => ({
    root: {
        width: '100%'
    },
    table: {
        minWidth: 500
    },
    tableWrapper: {
        overflowX: 'auto'
    },
    tableWrapperStudyGlobal : {
        overflowX: 'auto',
        overflowY: 'scroll',
        maxHeight: '219px'
    },
    tableWrapperStudyLocal : {
        overflowX: 'auto',
        overflowY: 'scroll',
        maxHeight: '900px'
    }
});

export default withStyles(styles)(TableWrapper);
